const $inject = ['$scope','$routeParams', 'dataService', 'settingsService'];

const lbaMultiSelectGroupCtrl = function ($scope, $routeParams, dataService, settingsService) {
  const vm = this;

  const parentDataLookUp = dataService.spiltDataAt(vm.settings.parent.dataAt, $routeParams);
  const childDataLookUp = dataService.spiltDataAt(vm.settings.child.dataAt, $routeParams);

  // Copy all functionality
  function copyTextToClipboard(text) {
    const textArea = document.createElement("textarea");
    textArea.style.position = 'fixed';
    textArea.style.top = 0;
    textArea.style.left = 0;
    textArea.style.width = '2em';
    textArea.style.height = '2em';
    textArea.style.padding = 0;
    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';
    textArea.style.background = 'transparent';
    textArea.value = text;

    document.body.appendChild(textArea);
    textArea.select();

    try {
      const successful = document.execCommand('copy');
      const msg = successful ? 'successful' : 'unsuccessful';
      console.log('Copying text command was ' + msg);
    } catch (err) {
      console.log('Oops, unable to copy');
    }

    document.body.removeChild(textArea);
  }

  vm.copyParentItems = function() {
    if (vm.parent.data && vm.parent.data.length > 0) {
      copyTextToClipboard(vm.parent.data.join(', '));
    }
  };

  vm.copyChildItems = function() {
    if (vm.child.data && vm.child.data.length > 0) {
      copyTextToClipboard(vm.child.data.join(', '));
    }
  };

  vm.parent = {};
  vm.parent.data = _.get(dataService.data.activeItem, parentDataLookUp);
  vm.parent.items = settingsService.options[vm.settings.parent.optionsAt];

  $scope.$watchCollection('vm.parent.data', (newData, oldData) => {
    if (newData !== oldData) {
      _.set(dataService.data.activeItem, parentDataLookUp, newData)
      vm.child.items =  [...newData];
      vm.child.data = vm.child.data.filter(i => newData.includes(i));
    }
  });

  vm.child = {};
  const childData = _.get(dataService.data.activeItem, childDataLookUp) || [];
  vm.child.data = childData.filter(i => vm.parent.data.includes(i));
  vm.child.items = vm.parent.data

  $scope.$watchCollection('vm.child.data', (newData, oldData) => {
    if (newData !== oldData) {
      _.set(dataService.data.activeItem, childDataLookUp, newData)
    }
  });
};

lbaMultiSelectGroupCtrl.$inject = $inject;

export default lbaMultiSelectGroupCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaMultiSelectGroup/lbaMultiSelectGroupCtrl.js